<h2 mat-dialog-title>Indikation für {{ material.bezeichnung }}</h2>
<mat-dialog-content>
    <mat-form-field style="width: 100%" [attr.data-cy]="'aiaitmdaitmd_mat-form-field_1_8_'">
        <input
            type="text"
            matInput
            placeholder="Bezeichnung"
            [formControl]="diagnoseCtrl"
            [attr.data-cy]="'aiaitmdaitmd_input_1_1_'"
        />
    </mat-form-field>
    <p *ngIf="tierarten?.length == 0" [attr.data-cy]="'aiaitmdaitmd_p_1_1_'">Bitte zunächst Tierarten einpflegen!</p>
    <mat-form-field *ngIf="tierarten?.length > 0" style="width: 100%">
        <mat-label [attr.data-cy]="'aiaitmdaitmd_mat-label_1_9_'">Tierart</mat-label>
        <mat-select
            [formControl]="tierartCtrl"
            [compareWith]="tierartComparator"
            multiple
            [attr.data-cy]="'aiaitmdaitmd_mat-select_1_6_'"
        >
            <mat-option
                *ngFor="let t of tierarten; let i = index"
                [value]="t"
                [attr.data-cy]="'aiaitmdaitmd_mat-option_1_7_' + i"
                >{{ t.tierart }}</mat-option
            >
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" [attr.data-cy]="'aiaitmdaitmd_button_1_0_'">Abbrechen</button>
    <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="!diagnoseCtrl.value || tierarten?.length == 0"
        [attr.data-cy]="'aiaitmdaitmd_button_2_0_'"
        >Speichern</button
    >
</mat-dialog-actions>
